<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">Japan VC Radar 2023</h1>
                <span class="meta"> Posted in January 2024 </span>
<!--
                <figure>
                  <img class="img-fluid" src="img/blog/card/vc-radar-2023_thumb.png" alt="">
                </figure>
-->
                <p>The 2023 edition of the VC Radar™ reflects Japan’s most active Lead VCs in 2023.</p>
                <p>Specifically, this infographic depicts the number of new investments led by Japan’s independent venture capital funds into domestic startups last year. Only investments in which the VC firm served as Lead investor for a startup that was not already in their portfolio are counted here.</p>
<!--                <p>We believe this is an important tool for Japan’s growing startup ecosystem. You can read more about our rationale <a href="http://azf.vc/lead">here</a> (special thanks to Mayumi for compiling this data !).</p>
                <p>[One additional note: we strive for full accuracy on this infographic and apologize for any mistakes. Feel free to direct any requested corrections to <a href="mailto:infographic@shizen.vc">infographic@shizen.vc</a>.]</p>
-->
                <figure>  <img class="img-fluid" src="img/blog/card/VCRadar2023.png" alt=""> </figure>

              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
